module.exports = __webpack_public_path__ + "img/icon-27.688e4f7e.svg";